export enum MessageType {
    none = 0,
    saveParent = 1,
    close = 2,
    customerAndLocation = 3,
    getData = 4,
    changed = 5,
    searchChanged = 6,
    goTo = 7,
    refresh = 8,
    clear = 9,
    setPristine = 10,
    goToNewDQOI = 11,
    getDQOIItem = 12,
    dqoiPopup = 20,
    createInvoiceFromOrderBill = 21,
    loaderOn=50,
    loaderOff = 51,
    miniLoaderOn = 52,
    miniLoaderOff = 53,
    taxCodeLoaderOff = 55,
    createOrderFromParts = 100,
    createOrderFromJob = 105,
    assignNewTech = 120,
    reassignTech = 121,
    messageInfo = 130,
    msgPopup = 140,
    disableMainTabs = 150,
    enableMainTabs = 151,
    reCalculate = 160,
    validateDispatchBeforeDrop = 170,
    hotKeyOn = 180,
    hotKeyOff = 181,
    gotoDispatchHistory = 182,
    changedCM = 190,
    childSaved = 201,
    pricesCleared = 202,
    aggregateResultsUpdated = 203,
    gotoInvoice = 204,
}